import firebase from 'firebase/app';
import { FirebaseCourseWithUid } from '../types/types';

export const deleteCourse = async (firebaseCourse: FirebaseCourseWithUid) =>
  firebase
    .firestore()
    .collection('courses')
    .doc(firebaseCourse.uid)
    .delete()
    .then(() => {
      firebase
        .storage()
        .ref(`courseImages/${firebaseCourse.uid}`)
        .listAll()
        .then((files) => {
          files.items.map((item) => item.delete());
        });
    });
